import { Component } from '@angular/core';
import { TranslateService} from '@ngx-translate/core';
import { MainService } from './services/main.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private translateService: TranslateService,
              private mainService: MainService) {
                translateService.setDefaultLang(this.mainService.getLanguage() + '-' + this.mainService.getSource());
                console.dir('1.0.003');
  }
}
